import { Outlet, useLocation } from 'react-router'

export default function AuthLayout() {
  const location = useLocation()
  const isPro = location.pathname.includes('register-pro')

  return (
    <div className="flex min-h-screen">
      {/* Left: Auth form */}
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-20 xl:px-24">
        <div className={`mx-auto w-full ${isPro ? 'max-w-md' : 'max-w-sm'}`}>
          <a href="/" className="mb-8 block text-xl font-bold text-primary">
            AfficheServices
          </a>
          <Outlet />
        </div>
      </div>

      {/* Right: Branding panel — context-aware */}
      <div className={`hidden lg:flex lg:flex-1 lg:flex-col lg:justify-center lg:px-12 ${
        isPro ? 'bg-gradient-to-br from-slate-900 to-slate-800' : 'bg-gradient-to-br from-blue-600 to-blue-800'
      }`}>
        {isPro ? (
          /* Pro-specific panel */
          <div className="max-w-md">
            <div className="inline-flex items-center gap-2 rounded-full bg-emerald-500/20 px-3 py-1 text-xs font-semibold text-emerald-400">
              <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" /></span>
              Des particuliers cherchent un pro maintenant
            </div>
            <h2 className="mt-4 text-2xl font-bold text-white">Développez votre activité</h2>
            <p className="mt-2 text-sm text-slate-400">Recevez des demandes de devis qualifiées de particuliers près de chez vous.</p>

            <ul className="mt-8 space-y-4">
              {[
                { text: '2 leads gratuits par mois — sans carte bancaire', icon: '🎁' },
                { text: 'Profil professionnel visible par des milliers de particuliers', icon: '👁️' },
                { text: 'SIRET vérifié = badge "Artisan vérifié" sur votre profil', icon: '✅' },
                { text: 'Avis clients pour renforcer votre réputation', icon: '⭐' },
                { text: 'Aucune commission sur vos chantiers', icon: '💰' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3 text-sm text-slate-300">
                  <span className="mt-0.5 text-base">{item.icon}</span>
                  {item.text}
                </li>
              ))}
            </ul>

            {/* Early adopter badge */}
            <div className="mt-10 rounded-xl bg-white/5 p-5 backdrop-blur-sm text-center">
              <p className="text-xs font-semibold uppercase tracking-wider text-emerald-400">Offre de lancement</p>
              <p className="mt-2 text-sm text-slate-300">
                Les premiers artisans inscrits bénéficient d'un profil prioritaire et d'un accompagnement personnalisé.
              </p>
            </div>
          </div>
        ) : (
          /* Default panel for login/register */
          <div className="max-w-md">
            <h2 className="text-2xl font-bold text-white">Pourquoi AfficheServices ?</h2>
            <ul className="mt-6 space-y-4">
              {[
                'Artisans vérifiés via le registre SIRENE (INSEE)',
                'Jusqu\'à 3 devis gratuits sous 48h',
                'Service 100% gratuit pour les particuliers',
                'Comparaison transparente des prix et avis',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-blue-100">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/20 text-[10px] font-bold text-white">✓</span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="mt-12 grid grid-cols-3 gap-6">
              <div>
                <div className="text-2xl font-bold text-white">100%</div>
                <div className="mt-1 text-sm text-blue-200">Artisans vérifiés</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white">48h</div>
                <div className="mt-1 text-sm text-blue-200">Délai de réponse</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white">Gratuit</div>
                <div className="mt-1 text-sm text-blue-200">Pour les particuliers</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
